import 'react-app-polyfill/ie11';
import 'core-js/es/object/values';
import 'core-js/es/promise';
import 'core-js/es/array';
import 'core-js/stable/string';
import 'core-js/stable/number';

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import * as FullStory from '@fullstory/browser';
import { datadogLogs } from '@datadog/browser-logs';

import store from './configureStore';
import './polyfills';
import './index.css';
import App from './AppWrappedLD';
import * as serviceWorker from './serviceWorker';
import configs from './constants/configs';

declare global {
    interface Window {
        _env_: {
            CREATE_SERVICE: string;
            SERVICE_EMAIL_DESIGNER: string;
            WEB_APP: string;
            REALTIME: string;
            LAUNCH_DARKLY: string;
            YOUTUBE_API_KEY: string;
            DD_KEY: string;
            PENDO_KEY: string;
            FULL_STORY_ORG_ID: string;
            STAFFBASE_API: string;
            MEMBER_SITE_BE_URL: string;
        };
    }
}

if (configs.fullStoryEnabled) {
    FullStory.init({
        orgId: configs.fullStoryOrgID,
        namespace: 'FS',
        recordOnlyThisIFrame: true,
        devMode: configs.NODE_ENV !== 'production',
    });
}

if (configs.datadogEnabled) {
    datadogLogs.init({
        clientToken: window._env_.DD_KEY,
        forwardErrorsToLogs: true,
        sampleRate: 100,
        service: 'ED-v3',
        env: configs.AWS_ENV_REGION,
        version: configs.reactAppVersion,
    });
}

/*
         _ _  __
   _ __ (_) |/ /__ _ ___ ___  ___
  | '_ \| | ' // _` / __/ __|/ _ \
  | |_) | | . \ (_| \__ \__ \ (_) |
  | .__/|_|_|\_\__,_|___/___/\___/
  |_|

*/

render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
